// extracted by mini-css-extract-plugin
export default {"container":"TK-z","topReviewHeading":"UK-z","criticalReview":"VK-z","favorableReview":"WK-z","vsSeparator":"XK-z"};